import React from "react";
import Page from "../../components/Page";
import Portada from "./Portada";
import PortadaMobil from "./PortadaMobil";
import { Box } from "@mui/material";

const Home = () => {
	return (
		<Page title="Sinapsis">
			<Box sx={{ display: { sm: "block", xs: "none" } }}>
				<Portada />
			</Box>
			<Box sx={{ display: { sm: "none", xs: "block" } }}>
				<PortadaMobil />
			</Box>
		</Page>
	);
};

export default Home;
